import * as Vue from 'vue'
import PropTypes from 'ant-design-vue/es/_util/vue-types'

const ProConfigProviderProps = {
  i18nRender: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).def(false),
  contentWidth: PropTypes.oneOf(['Fluid', 'Fixed']).def('Fluid'),
  breadcrumbRender: PropTypes.func,
}

const ConfigProvider = {
  name: 'ProConfigProvider',
  props: ProConfigProviderProps,
  provide() {
    const _self = this
    return {
      locale: _self.$props.i18nRender,
      contentWidth: _self.$props.contentWidth,
      breadcrumbRender: _self.$props.breadcrumbRender,
    }
  },
  render() {
    // Vue 3 兼容：使用 $slots 而不是 $scopedSlots
    // 同时兼容 Vue 2 和 Vue 3
    const slots = this.$slots || this.$scopedSlots || {}
    const defaultSlot = slots.default || (this.$scopedSlots && this.$scopedSlots.default)
    
    // 获取子内容
    let children = null
    if (typeof defaultSlot === 'function') {
      children = defaultSlot()
    } else if (defaultSlot) {
      children = defaultSlot
    } else if (this.children) {
      // Vue 2 兼容
      children = this.children
    }
    
    // 如果没有子内容，返回 null
    if (!children) {
      return null
    }
    
    // 关键修复：确保只返回一个根元素
    // ContainerQuery 等组件严格要求只有一个子元素
    // 如果是数组，必须只返回第一个元素
    if (Array.isArray(children)) {
      // 过滤掉 null/undefined/false/空字符串
      const validChildren = children.filter(child => {
        if (child == null || child === false || child === '') {
          return false
        }
        // 检查是否是有效的 VNode
        if (typeof child === 'object') {
          return child.type !== undefined || child.__v_isVNode === true || child.component !== undefined
        }
        return true
      })
      
      if (validChildren.length === 0) {
        return null
      } else if (validChildren.length === 1) {
        // 只有一个有效子元素，直接返回
        return validChildren[0]
      } else {
        // 多个子元素，只返回第一个（ContainerQuery 要求只有一个）
        // 这是关键修复：ContainerQuery 只能有一个子元素
        console.warn('ConfigProvider: Multiple children detected (' + validChildren.length + '), returning first child only for ContainerQuery compatibility')
        console.warn('Children types:', validChildren.map(c => ({ 
          type: c?.type, 
          component: c?.component?.name,
          isVNode: c?.__v_isVNode 
        })))
        return validChildren[0]
      }
    }
    
    // 单个子元素，直接返回
    // 再次检查，确保不是数组（防止某些边缘情况）
    if (Array.isArray(children)) {
      console.warn('ConfigProvider: children 是数组但未通过 Array.isArray 检查，返回第一个元素')
      return children[0] || null
    }
    
    return children
  },
}

export default ConfigProvider
